import { render } from "./Animation.vue?vue&type=template&id=6c865db4&scoped=true"
import script from "./Animation.vue?vue&type=script&lang=js"
export * from "./Animation.vue?vue&type=script&lang=js"

import "./Animation.vue?vue&type=style&index=0&id=6c865db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c865db4"]])

export default __exports__